var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4501 25.5651C43.8651 24.9801 42.9201 24.9801 42.3351 25.5651L35.0001 32.8851L27.6651 25.5501C27.0801 24.9651 26.1351 24.9651 25.5501 25.5501C24.9651 26.1351 24.9651 27.0801 25.5501 27.6651L32.8851 35.0001L25.5501 42.3351C24.9651 42.9201 24.9651 43.8651 25.5501 44.4501C26.1351 45.0351 27.0801 45.0351 27.6651 44.4501L35.0001 37.1151L42.3351 44.4501C42.9201 45.0351 43.8651 45.0351 44.4501 44.4501C45.0351 43.8651 45.0351 42.9201 44.4501 42.3351L37.1151 35.0001L44.4501 27.6651C45.0201 27.0951 45.0201 26.1351 44.4501 25.5651Z",
    fill: "#EC5B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0ZM35 3.78378C52.2402 3.78378 66.2162 17.7598 66.2162 35C66.2162 52.2402 52.2402 66.2162 35 66.2162C17.7598 66.2162 3.78378 52.2402 3.78378 35C3.78378 17.7598 17.7598 3.78378 35 3.78378Z",
    fill: "#E5E5EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0ZM35 3.78378C52.2402 3.78378 66.2162 17.7598 66.2162 35C66.2162 52.2402 52.2402 66.2162 35 66.2162C17.7598 66.2162 3.78378 52.2402 3.78378 35C3.78378 17.7598 17.7598 3.78378 35 3.78378Z",
    fill: "#EC5B62"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorCircle);
export default __webpack_public_path__ + "static/media/icon_error_circle.8a232bbce577ccfc8850c57a62456ae3.svg";
export { ForwardRef as ReactComponent };